/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type tradeVerifyFirmReminderQueryVariables = {
    userId: string;
};
export type tradeVerifyFirmReminderQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly verifiedTradeStatus: string | null;
        } | null;
    } | null;
};
export type tradeVerifyFirmReminderQuery = {
    readonly response: tradeVerifyFirmReminderQueryResponse;
    readonly variables: tradeVerifyFirmReminderQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "verifiedTradeStatus",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "tradeVerifyFirmReminderQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "tradeVerifyFirmReminderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "tradeVerifyFirmReminderQuery",
    "id": "ferrum/237.0.0-2019-10-16T19:34:20.640Z/tradeVerifyFirmReminderQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '82a3a6eb4a4103d9d58f8117686047cc';
export default node;
